.slide {
    position: relative;
    aspect-ratio: 344 / 431;
    margin: 0;
}

.clickable {
    position: absolute;
    inset: 0;
    z-index: 2;
}

.imageContainer {
    position: absolute;
    inset: 0;
    z-index: 0;
}

.image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.textContent {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: var(--spacer-8);
    background: var(--overlay-black-gradient);
    overflow: hidden;
    padding: var(--spacer-24);
    z-index: 1;
}

.bigText {
    font: var(--font-h-40);
}

.textHeading {
    font: var(--font-h-24-forma);
}

.textBody {
    font: var(--font-p-16);
}

.caption {
    composes: textContent;
    inset-block-start: auto;
    padding: var(--spacer-104) var(--spacer-24) var(--spacer-24);
}

.captionLabel {
    font: var(--font-button-16);
    text-align: center;
}
